import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute — gates children behind auth.
 * If `permission` is provided, additionally checks the user's permission set.
 */
const ProtectedRoute = ({ children, permission }) => {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: 'var(--navy)' }} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force password change on first login (temp password).
  if (user.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password?forced=1" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#c0392b' }} data-testid="permission-denied">
        <h2>Access Denied</h2>
        <p>You don't have permission to view this page. Contact your Super Admin.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
